module.exports = __webpack_public_path__ + "static/media/type-tv.0be155ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/type-tv.svg
// module id = 124
// module chunks = 0